<script setup lang="ts">
import type { IProps } from './career-eRecruiterOffer.types'
import UiButton from '@/components/UiButton/UiButton.vue'

defineProps<IProps>()

</script>

<template>
  <div
    class="ERecruiter-Offer"
  >
    <h4 class="ERecruiter-Offer__header">
      {{ offer.title }}
    </h4>

    <p class="ERecruiter-Offer__region">
      <span v-if="offer.jobType">{{ offer.jobType }}</span>

      <span
        v-if="offer.jobType"
        class="ERecruiter-Offer__divider"
      />

      <br >

      <span>{{ offer.location }}, {{ offer.region }}</span>
    </p>

    <div class="ERecruiter-Offer__link">
      <UiButton
        :to="offer.url"
        target="_blank"
      >
        Zobacz więcej
      </UiButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ERecruiter-Offer {
  display: flex;
  flex-direction: column;
  min-height: 212px;
  padding: 2.4rem;
  background: transparent;
  border: 1px solid $gray-400;
  border-radius: 1.2rem;

  &:hover {
    background: $white;
    border: 2px solid $purple-400;
  }

  &__header {
    @include h9;
    margin-bottom: 0.8rem;
  }

  &__region {
    @include body-1-medium;
    margin-bottom: 0.8rem;
    color: $text-500;
    text-transform: capitalize;
  }

  &__divider {
    display: inline-block;
    height: 1.65rem;
    margin: -0.25rem 0.8rem;
    border-right: 2px solid $text-500;
  }

  &__link {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: flex-end;
  }
}

@include atM {
  .ERecruiter-Offer {
    min-height: 292px;
    padding: 3.2rem 4.0rem 4.0rem 4.0rem;

    &__header {
      @include h8;
      margin-bottom: 2.5rem;
    }

    &__region {
      margin-bottom: 6rem;
    }
  }
}
</style>
